var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9664 2.63117C26.9485 3.08143 25.869 3.37714 24.7637 3.5085C25.9287 2.81175 26.8007 1.71519 27.2171 0.423171C26.1237 1.07384 24.9251 1.52984 23.6757 1.7765C22.8365 0.878609 21.7242 0.283122 20.5117 0.0826171C19.2991 -0.117887 18.0543 0.0878255 16.9707 0.667775C15.8872 1.24772 15.0256 2.16942 14.5199 3.28956C14.0142 4.40971 13.8927 5.66554 14.1744 6.86184C11.9572 6.75071 9.78817 6.17454 7.80811 5.17072C5.82805 4.16691 4.08123 2.7579 2.68106 1.03517C2.18545 1.88644 1.925 2.85414 1.9264 3.83917C1.9264 5.7725 2.9104 7.48051 4.4064 8.4805C3.52107 8.45263 2.65524 8.21355 1.88106 7.78317V7.8525C1.88133 9.14011 2.32689 10.388 3.14219 11.3846C3.9575 12.3812 5.09237 13.0651 6.3544 13.3205C5.53255 13.5432 4.6708 13.576 3.8344 13.4165C4.19022 14.5248 4.88374 15.4941 5.81785 16.1887C6.75196 16.8832 7.8799 17.2682 9.04373 17.2898C7.88704 18.1983 6.56263 18.8698 5.14624 19.2661C3.72984 19.6623 2.24923 19.7755 0.789062 19.5992C3.33799 21.2384 6.30519 22.1087 9.33573 22.1058C19.5931 22.1058 25.2024 13.6085 25.2024 6.23917C25.2024 5.99917 25.1957 5.75651 25.1851 5.51917C26.2769 4.73006 27.2192 3.75253 27.9677 2.6325L27.9664 2.63117Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlack);
export default __webpack_public_path__ + "static/media/twitterBlack.007b69cfd68387f74c94d2ece1ab5a9d.svg";
export { ForwardRef as ReactComponent };